import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Check } from 'lucide-react';
import { InlineWidget } from 'react-calendly';

const CALENDLY_URL = "https://calendly.com/valoryx-info/30min";

// Google Ads Tag - UPDATE THESE WITH YOUR ACTUAL IDS
const GOOGLE_ADS_ID = 'AW-18151655378';
const GOOGLE_CONVERSION_LABEL = 'PLACEHOLDER';

export default function GoogleThankYouPage() {
  const location = useLocation();
  const { contactName, contactLastName, emailValue } = location.state || {};
  const displayName = contactName || '';
  const displayLastName = contactLastName || '';

  // Load Google Ads Tag & fire conversion
  useEffect(() => {
    if (GOOGLE_ADS_ID === 'AW-PLACEHOLDER') return;

    if (!window._googleAdsLoaded) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
      script.async = true;
      document.head.appendChild(script);

      const inlineScript = document.createElement('script');
      inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GOOGLE_ADS_ID}');
      `;
      document.head.appendChild(inlineScript);
      window._googleAdsLoaded = true;
    }

    // Fire conversion event
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        'send_to': `${GOOGLE_ADS_ID}/${GOOGLE_CONVERSION_LABEL}`,
      });
    }
  }, []);

  return (
    <div
      className="min-h-screen relative overflow-hidden bg-white"
      data-testid="google-quiz-thank-you"
    >
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full opacity-[0.04]"
        style={{ background: 'radial-gradient(circle, #2E7CF6 0%, transparent 70%)' }}
      />
      <div className="relative z-10 max-w-3xl mx-auto px-6 pt-20 pb-8 text-center">
        <div className="w-14 h-14 rounded-full bg-[#2E7CF6]/10 border border-[#2E7CF6]/20 flex items-center justify-center mx-auto mb-6">
          <Check className="w-7 h-7 text-[#2E7CF6]" />
        </div>
        <h1
          className="text-2xl sm:text-3xl text-slate-900 leading-tight mb-3 font-black tracking-tight"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          Vielen Dank{displayName ? `, ${displayName} ${displayLastName}` : ''}!
        </h1>
        <p className="text-base text-slate-500 leading-relaxed mb-2" style={{ fontFamily: "'Manrope', sans-serif" }}>
          Wir haben deine Angaben erhalten. Buche jetzt direkt deinen kostenlosen Ersttermin:
        </p>
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-6 pb-10">
        <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-sm" data-testid="google-calendly-embed">
          <InlineWidget
            url={CALENDLY_URL}
            prefill={{
              name: `${displayName} ${displayLastName}`.trim(),
              email: emailValue || '',
            }}
            styles={{ height: '660px', minWidth: '320px' }}
            pageSettings={{
              backgroundColor: 'ffffff',
              hideEventTypeDetails: false,
              hideLandingPageDetails: false,
              primaryColor: '2E7CF6',
              textColor: '0f172a',
            }}
          />
        </div>
        <div className="text-center mt-6">
          <a
            href="/google"
            className="inline-block px-6 py-2.5 border border-slate-200 text-slate-400 text-sm rounded-lg hover:bg-slate-50 hover:text-slate-600 transition-all"
          >
            Zurück zur Startseite
          </a>
        </div>
      </div>
    </div>
  );
}
